<template>
  <div class="post-container" :class="{ 'is-comment': isComment }">
    <!-- Mostrar contexto de padres si es comentario -->
    <div v-if="parentChain.length" class="parent-chain">
      <div v-for="parent in parentChain" :key="parent.id" class="parent-post">
        <PostCard :post="parent" :isParentPreview="true" />
      </div>
    </div>
  <!-- Post principal o comentario -->
  <PostCard :post="post" :isComment="isComment" @openPost="goToPostDetail" />
    <!-- Comentarios hijos -->
    <div v-if="childComments.length" class="child-comments">
      <AppPost
        v-for="child in visibleChildComments"
        :key="child.id"
        :post="child"
        :allPosts="allPosts"
        :level="level + 1"
      />
      <button v-if="showLoadMore" @click="loadMoreComments" class="btn-load-more">Cargar más...</button>
    </div>
  </div>
</template>


<script>
import PostCard from './PostCard.vue';
import { useRouter } from 'vue-router';

export default {
  name: 'AppPost',
  components: { PostCard, AppPost: () => import('./AppPost.vue') },
  props: {
    post: { type: Object, required: true },
    allPosts: { type: Array, required: true },
    level: { type: Number, default: 0 },
    maxParent: { type: Number, default: 3 },
    maxChild: { type: Number, default: 4 },
    maxComments: { type: Number, default: 3 },
  },
  data() {
    return {
      commentsToShow: this.maxComments,
      router: null,
    };
  },
  created() {
    // Inicializa router en el ciclo de vida de Vue 2/3 Options API
    this.router = useRouter();
  },
  computed: {
    isComment() {
      return this.post && this.post.postPadreId != null;
    },
    parentChain() {
      // Devuelve hasta maxParent posts padres hacia arriba
      let chain = [];
      let current = this.post;
      let count = 0;
      while (current && current.postPadreId != null && count < this.maxParent) {
        const parent = this.allPosts.find(p => p.id === current.postPadreId);
        if (!parent) break;
        chain.unshift(parent);
        current = parent;
        count++;
      }
      return chain;
    },
    childComments() {
      // Devuelve comentarios hijos directos
      if (this.level >= this.maxChild) return [];
      return this.allPosts.filter(p => p.postPadreId === this.post.id);
    },
    visibleChildComments() {
      // Ordenar por likes (desc), mostrar hasta commentsToShow
      return this.childComments
        .slice()
        .sort((a, b) => (b.likes || 0) - (a.likes || 0))
        .slice(0, this.commentsToShow);
    },
    showLoadMore() {
      return this.childComments.length > this.commentsToShow;
    },
  },
  methods: {
    loadMoreComments() {
      this.commentsToShow += this.maxComments;
    },
    goToPostDetail(post) {
      // Navega a la ruta de detalle del post
      this.router.push({ name: 'PostDetail', params: { id: post.id } });
    },
  },
};
</script>

<style scoped>
.post-container {
  margin-bottom: 2rem;
}
.is-comment {
  margin-left: 2rem;
  border-left: 2px solid #ccc;
  padding-left: 1rem;
}
.parent-chain {
  margin-bottom: 1rem;
  opacity: 0.7;
}
.child-comments {
  margin-top: 1rem;
}
.btn-load-more {
  background: #6a0dad;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  cursor: pointer;
  margin-top: 0.5rem;
}
</style>
